export const isMobile = (): boolean => {
  return (
    /Mobi|Android|iPhone/i.test(navigator.userAgent) ||
    (/Safari/i.test(navigator.userAgent) && navigator.maxTouchPoints > 0)
  );
};
